import api from './api';
import { Agencia, CreateAgenciaDTO, UpdateAgenciaDTO } from '../types/agencia';

export const agenciaService = {
  // Listar todas as agências
  listarAgencias: async (): Promise<Agencia[]> => {
    const response = await api.get('/agencias');
    return response.data;
  },

  // Buscar uma agência específica
  buscarAgencia: async (id: number): Promise<Agencia> => {
    const response = await api.get(`/agencias/${id}`);
    return response.data;
  },

  // Criar uma nova agência
  criarAgencia: async (agencia: CreateAgenciaDTO): Promise<Agencia> => {
    const response = await api.post('/agencias', agencia);
    return response.data;
  },

  // Atualizar uma agência existente
  atualizarAgencia: async (id: number, agencia: UpdateAgenciaDTO): Promise<Agencia> => {
    const response = await api.put(`/agencias/${id}`, agencia);
    return response.data;
  },

  // Excluir uma agência
  excluirAgencia: async (id: number): Promise<void> => {
    await api.delete(`/agencias/${id}`);
  }
}; 